import React, { useEffect } from 'react';
import PageNavigatorBox from '../PageNavigatorBox';
import SearchBox from './SearchBox';
import MatchsBox from '../MatchsBox';
import { useLibraryContext } from '../../context/LibraryContext';
import { isMobile } from 'react-device-detect';
import { useFolderContext } from '../../context/FolderContext';
import { useSearchContext } from '../../context/SearchContext';
import { useTokenContext } from '../../context/TokenContext';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from '@progress/kendo-react-tooltip';
import { showMessage } from '../../languages/_showmessages';

interface HeaderProps {
  isSearch: boolean;
  setIsSearch: React.Dispatch<React.SetStateAction<boolean>>;
  isSearchBoxVisible: boolean;
  setIsSearchBoxVisible: React.Dispatch<React.SetStateAction<boolean>>;
  isDocAIVisible: boolean;
  setIsDocAIVisible: React.Dispatch<React.SetStateAction<boolean>>;
  elapsedTime: number;
}

export const Header: React.FC<HeaderProps> = ({ isSearch, setIsSearch, isSearchBoxVisible, setIsSearchBoxVisible, isDocAIVisible, setIsDocAIVisible, elapsedTime }) => {
  const { Library } = useLibraryContext();
  const [ headerImgStyle, setHeaderImgStyle ] = React.useState<React.CSSProperties>({});
  const { Folder } = useFolderContext();
  const { Search } = useSearchContext();
  const { tokenContext, setTokenContext } = useTokenContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (Library && Library?.headerImg?.contentType !== undefined && Library?.headerImg?.fileContents !== undefined) {
      setHeaderImgStyle({
        backgroundImage: `url(data:${Library.headerImg.contentType};base64,${Library.headerImg.fileContents})`,
        backgroundRepeat: 'repeat',
      });
    } 
  }, [Library]);

  const logoImg = () => {
    if (Library === null || Library.logoImg === null || Library?.logoImg?.fileContents === undefined) {
      return 'unset';
    }
    return `url(data:${Library.logoImg.contentType};base64,${Library!.logoImg.fileContents})`;
  }

  const logoImgStyle = {
    backgroundImage: logoImg(),
    backgroundRepeat: 'no-repeat',
    width: '300px',
    height: '60px',
    cursor: 'pointer',
  };

  const logoUrl = () => {
    if (Library !== null) {
      window.open(Library.logoUrl, '_blank');
    };
  }

  const logout = () => {
    setTokenContext(null);
    navigate("/login?redirectto=" + window.location.href.replace("?redirectto=" + window.location.href, ""));
  }

  return (
    <>
      <div className='header' style={headerImgStyle}>
        {isMobile ? 
          <>
            <SearchBox isSearch={isSearch} setIsSearch={setIsSearch} isSearchBoxVisible={isSearchBoxVisible} setIsSearchBoxVisible={setIsSearchBoxVisible} />

            <header className='header-mobile'>
              <div className='headerleft-mobile'/>

              <div className='headermiddle-mobile'>
                <div className='navigationbox-mobile'>
                  <div className="right mobile-right">
                      <PageNavigatorBox />
                  </div>
                              
                  {Search?.pagesCount ?? 0 > 0 ? <MatchsBox /> : <></>}
                </div>
              </div>
            </header>
          </>
        :    
          <>
            <div className='header-desktop'>
              <div className='headerleft' style={logoImgStyle} onClick={() => logoUrl()}>{(Library?.logoImg === null) ? Library?.description : ''}</div>

              <div className='headermiddle'>
                <div className='navigationbox'>
                  <div>
                    <SearchBox isSearch={isSearch} setIsSearch={setIsSearch} isSearchBoxVisible={isSearchBoxVisible} setIsSearchBoxVisible={setIsSearchBoxVisible} />
                  </div>

                  {/* <img onClick={() => setIsDocAIVisible(!isDocAIVisible)} className='docaibutton' alt='DocAI' src={require('../../assets/DocAIIcon.svg').default} /> */}

                  <div className="matchboxdiv">
                    <Tooltip position={"bottom"} anchorElement="target">
                      <span title={(elapsedTime / 1000).toFixed(3) + " " + showMessage("seconds")}>
                        {Search?.pagesCount ?? 0 > 0 ? <MatchsBox /> : <></>}
                      </span>
                    </Tooltip>
                  </div>

                  <div className="pagenavigationboxdiv">
                    <PageNavigatorBox />
                  </div>
                </div>
              </div>

              <div className='headerright'>
                <div className='docprologo' onClick={() => window.open("https://www.docpro.com.br", "_blank")} />
              </div>
            </div>

            {tokenContext?.userName?.trim() ?? '' !== '' ? 
              <>
                <div className='userloggeddiv'>
                  <span>{tokenContext?.userName}</span>,&ensp;
                  <span className='logoutdiv' onClick={() => logout()}>Sair</span>
                </div>
              </>
              :
              <></>
            }
          </>
        }

        <div>
          <div className='foldercurrent' data-content={Folder === null ? 'Carregando...' : Folder.Path} />
        </div>
      </div>

      <div className='documentedgediv'>
        <div className='documentedgecontentdiv' />
      </div>
    </>
  );
};

Header.displayName = 'Header';